var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logosDoctorElec0",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6200ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9D8DF1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128 249.491c67.098 0 121.492-54.393 121.492-121.491S195.098 6.508 128 6.508S6.509 60.902 6.509 128S60.902 249.491 128 249.491"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6200ee",
    d: "M128 0C57.308 0 0 57.308 0 128s57.308 128 128 128s128-57.307 128-128C256 57.308 198.693 0 128 0m0 13.017c63.503 0 114.983 51.48 114.983 114.983S191.503 242.983 128 242.983S13.017 191.503 13.017 128S64.497 13.017 128 13.017"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logosDoctorElec0)",
    d: "M129.446 36.881c50.324 0 91.119 40.796 91.119 91.119s-40.795 91.118-91.12 91.118c-50.323 0-91.118-40.795-91.118-91.118c0-12.298 2.437-24.028 6.854-34.733c6.449 8.783 16.85 14.484 28.581 14.484c19.57 0 35.435-15.865 35.435-35.435c0-11.732-5.701-22.132-14.484-28.581c10.705-4.417 22.434-6.854 34.733-6.854"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.971 107.029h-20.014V87.014h-13.914v20.015h-20.015v13.914h20.015v20.015h13.914v-20.015h20.014z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculo);
export default __webpack_public_path__ + "static/media/circulo.f68c0d1b2f58bea7c711af201e3556c6.svg";
export { ForwardRef as ReactComponent };